<script>
import GardenBoundary from './GardenBoundary.js'
export default {
    install(Vue, options) {
        if (window.loclyLocation) {
            window.loclyLocation.start()
            window.loclyLocation.on('unifiedPositionChange', (e) => {
                console.log('position', e)
                // Store the user's location
                options.store.commit('location', e)

                // Store whether the user is inside the boundaries of NYBG
                options.store.commit('inGarden', window.loclyLocation.isUnifiedInsidePolygon(GardenBoundary))

                // We need this exposed to the outside world
                window.isInGarden = options.store.state.inGarden
            })
        }
    }
}
</script>